import {
  slateGrey,
  grey900,
  greyA100,
  lightBlue900,
  blue700,
  lightBlueGrey,
  yellow800,
  peacockBlue,
  white,
} from './colors';

const cars = {
  totalCars: slateGrey,
  selected: blue700,
  filters: {
    border: greyA100,
    text: grey900,
    count: slateGrey,
    selectedFilter: lightBlue900,
  },
  priceBackground: {
    lightBlueGrey,
  },
  highlightedBorder: yellow800,
  carCard: {
    text: peacockBlue,
  },
  promo: {
    text: white,
  },
};

export default cars;
